module.exports = __webpack_public_path__ + "img/main-facility-conference.2faaf3b9.jpg";